// extracted by mini-css-extract-plugin
module.exports = {"background":"App_keto_background__2zgCI"};